module.exports = __webpack_public_path__ + "static/img/xueye_.e586384f.png";